import { bindActionCreators } from 'redux';
import { closeMessageModal } from '../../../redux/members/actions';

const map = (dispatch) => ({
  ...bindActionCreators(
    {
      closeModal: closeMessageModal,
    },
    dispatch,
  ),
});

export default map;
